import { UserExtended } from "../domain/UserExtended";
import { UserNotFoundError } from "../domain/UserNotFoundError";
import { UserRepository } from "../domain/UserRepository";

export function getUserExtendedData(
  userRepository: UserRepository,
  userUid: string
): Promise<UserExtended> {
  
  return new Promise<UserExtended>((resolve, reject) => {
    userRepository
      .getUserExtendedData(userUid)
      .then((user) => {        
        resolve(user);
      })
      .catch((_error) => {
        reject(new UserNotFoundError("User not found"));
      });
  });
}
